// extracted by mini-css-extract-plugin
module.exports = {"box":"SelectableItemOption_box__3zr6n","boxContent":"SelectableItemOption_boxContent__QxJe7","img":"SelectableItemOption_img__1g0Ni","label":"SelectableItemOption_label__2Vxue"};